import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ProjectService, Employee, Company, ProjectEmployee, Partecipant } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, Page } from 'elbuild-ui-lib-core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';

@Component({
	selector: 'app-project-employee-add',
	templateUrl: './project-employee-add.component.html',
	styleUrls: ['./project-employee-add.component.scss']
})
export class ProjectEmployeeAddComponent implements OnInit {

	@Input()
	projectid: number;

	associablerows: Employee[] = [];
	allassociablerows: Employee[] = [];

	associaterows: ProjectEmployee[] = [];
	allassociaterows: ProjectEmployee[] = [];

	associableloading = true;
	associateloading = true;

	partecipants: Partecipant[];
	@Input()
	companyid: number;

	@Input()
	singlecompany: boolean;





	advancedSearch = new Search('projectemployee join employee on projectemployee.employeeid = employee.id');


	constructor(
		private projectService: ProjectService,
		private activeModal: NgbActiveModal,
		private crudService: CrudService<ProjectEmployee>,
		private partecipantService: CrudService<Partecipant>,
		private messageService: MessageService,
		private translateService: TranslateService
	) { }

	ngOnInit() {
		const search = new Search('partecipant');
		search.addSimpleFilter('entity', 'company');
		this.partecipantService.searchEntities(Partecipant, 'partecipant', search, search.page).subscribe((data: Partecipant[]) => {
			this.partecipants = data;
		});
	}

	loadAssociableEmployees(): void {
		this.associableloading = true;
		this.projectService.getAssociableEmployees(this.projectid, +this.companyid).subscribe((data: Employee[]) => {
			this.associablerows = data;
			this.allassociablerows = data;
			this.associableloading = false;
		});
	}

	loadAssociateEmployees(): void {
		this.associateloading = true;
		this.associaterows = [];

		if (this.projectid) {
			this.advancedSearch.addSimpleFilter('projectemployee.projectid', this.projectid);
		}

		if (+this.companyid) {
			this.advancedSearch.addSimpleFilter('employee.companyid', this.companyid);
		} else {
			this.advancedSearch.removeSimpleFilter('employee.companyid');
		}

		this.crudService.searchEntities(ProjectEmployee, 'projectemployee', this.advancedSearch, new Page(1000)).subscribe((data: ProjectEmployee[]) => {
			this.associaterows = data;
			this.allassociaterows = data;
			this.associateloading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.associateloading = false;
		});
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}

	add(employee: Employee): void {

		const projectemployee = new ProjectEmployee();
		projectemployee.projectid = this.projectid;
		projectemployee.employeeid = employee.id;

		this.crudService.createEntity(ProjectEmployee, 'projectemployee', projectemployee).subscribe((res) => {
			this.messageService.sendSuccess(
				this.translateService.instant('labels.employee-add-success'),
				this.translateService.instant('labels.success')
			);
			this.loadAssociableEmployees();
			this.loadAssociateEmployees();
		}, ({ error }) => {
			this.messageService.sendError(
				error.msg ? error.msg : error,
				this.translateService.instant('labels.event-save-error')
			);
		});
	}

	remove(projectemployee: ProjectEmployee): void {


		this.crudService.deleteEntity(ProjectEmployee, 'projectemployee', projectemployee).subscribe((res) => {
			this.messageService.sendSuccess(
				this.translateService.instant('labels.employee-remove-success'),
				this.translateService.instant('labels.success')
			);
			this.loadAssociableEmployees();
			this.loadAssociateEmployees();
		}, ({ error }) => {
			this.messageService.sendError(
				error.msg ? error.msg : error,
				this.translateService.instant('labels.event-save-error')
			);
		});
	}

	submit() {
		this.crudService.saveAll(ProjectEmployee, 'projectemployee', this.associaterows).subscribe((res) => {
			this.messageService.sendSuccess(
				this.translateService.instant('labels.projectemployee-save-success'),
				this.translateService.instant('labels.success')
			);
			this.loadAssociableEmployees();
			this.loadAssociateEmployees();
		}, ({ error }) => {
			this.messageService.sendError(
				error.msg ? error.msg : error,
				this.translateService.instant('labels.event-save-error')
			);
		});
	}

	updateFilter(event): void {
		const val = event.target.value.toLowerCase();

		if (val) {
			this.associablerows = this.allassociablerows.filter(e => {
				return e.fullname?.toLowerCase().indexOf(val) >= 0;
			});
			this.associaterows = this.allassociaterows.filter(e => {
				return e.fullname?.toLowerCase().indexOf(val) >= 0;
			});

		} else {
			this.associablerows = this.allassociablerows.filter(employee => true);
			this.associaterows = this.allassociaterows.filter(employee => true);
		}
	}

	reloadEmployees(): void {
		this.loadAssociableEmployees();
		this.loadAssociateEmployees();
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.loadAssociateEmployees();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.loadAssociateEmployees();
	}

}
